<template>
    <div class="dcheader">
        <div class="flex flex-ac" style="height: 100%;">
            <img src="@/assets/newimages/shopimg-default.png" class="logoimg" />
            <div style="max-width: 4rem;">
                <div class="ft-36 one-line-ellipsis color-666" style="line-height: 0.5rem;">{{ shop.name }}</div>
                <div class="ft-34 one-line-ellipsis color-666">{{ account }}</div>
            </div>
        </div>

        <div class="flex flex-ac flex-1 flex-jc">
            <span class="ft-40 ft-bold">{{ nowTime }}</span>
        </div>
        <div class="flex flex-ac flex-je" style="height: 100%;">
            <!-- <div class="flex flex-ac mg-rt30" v-if="showOrderLoading">
                <van-loading color="#FE724F" size="0.5rem" class="mg-rt10" />
                <span class="ft-36 color-666">刷新中</span>
            </div> -->
            <button class="openqianxiang-btn bg-FE724F mg-rt30" @click="openDaily">日报</button>
            <button class="openqianxiang-btn bg-1D5CFA mg-rt30 flex flex-ac flex-jc" @click.stop="openQianxiang">
                <van-icon name="setting" color="#fff" size="0.4rem" class="mg-rt15" @click.stop="openChooseBox" v-if="nowDevice == 'android' || nowDevice == 'mt_android'" />
                <van-loading v-if="isShowOpenLoading" color="#fff" size="0.4rem" class="mg-rt10" />
                钱箱
            </button>
            <button class="openqianxiang-btn bg-3DB956 mg-rt30" @click="changeModel"><van-icon name="exchange" size="0.38rem" color="#fff" class="mg-rt10" />{{ changeModelTextH }}</button>
            
            <div class="flex flex-ac mg-rt30" @click="showIpContModal">
                <img src="@/assets/newimages/IP.png" class="fixed ipimg" />
                <!-- <span class="ft-38 color-666">{{ localIp }}</span> -->
            </div>
            <template>
                <div class="flex flex-ac" v-if="connected">
                    <img src="@/assets/newimages/WIFI-on.png" class="fixed connectedstatus" />
                    <!-- <span class="ft-38 color-666">在线</span> -->
                </div>
                <div class="flex flex-ac" v-else>
                    <img src="@/assets/newimages/WIFI-off.png" class="fixed connectedstatus" />
                    <!-- <span class="ft-38 color-999">离线</span> -->
                </div>
            </template>
        </div>

        <!-- 切换模式 -->
        <div class="changemodel-modal" v-if="isShowModal">
            <div class="changemodel-box">
                <img src="@/assets/images/close.png" class="close absolute" alt srcset @click="closeModal" />
                <div class="modaltitle">{{ changeModelText }}</div>
                <div class="modalcont">
                    <div class="modalcont-item" v-if="managerMode == 1">
                        <div class="flex flex-ac">
                            <label class="modalcont-label">管理密码</label>
                            <input class="modalcont-input" type="password" @keyup.enter="confirmChange" v-model="originPaw" />
                        </div>
                        <div class="ft-30 color-666 mg-tp15 flex flex-ac" style="margin-left: 1.8rem;">
                            <van-icon name="info" color="#666" size="0.36rem" class="mg-rt15" />
                            默认管理密码为：123456
                        </div>
                        <div v-if="errorMsg != ''" class="ft-24 color-e60012 mg-tp15" style="margin-left: 1.8rem;">{{ errorMsg }}</div>
                    </div>
                    <div class="modalcont-text" v-if="managerMode == 0">确认切换为经营模式？</div>
                </div>
                <div class="btns flex flex-ac flex-jc">
                    <button class="cancel" @click="closeModal">取消</button>
                    <button class="confirm " @click="confirmChange">确认</button>
                </div>
            </div>
        </div>

        <!-- 日报弹窗 -->
        <div class="changemodel-modal daily-modal" v-if="isShowDaily">
            <div class="changemodel-box">
                <img src="@/assets/images/close.png" class="close absolute" alt srcset @click="closeDailyModal" />
                <div class="modaltitle">日报</div>
                <div class="modalcont">
                    <div class="search-value">
                        <div class="flex flex-ac mg-bt25">
                            <input v-model="start_time" class="ordernum-input search-date-input" readonly placeholder="选择时间"
                                @click="showCalendarStart = true" style="margin: 0 0 0 0.4rem" />
                            <span class="ft-38">&nbsp;&nbsp;至&nbsp;&nbsp;</span>
                            <input v-model="end_time" class="ordernum-input search-date-input" placeholder="选择时间" readonly
                                @click="showCalendarEnd = true" />
                        </div>
                        <div class="flex flex-ac search-item">
                            <div class="flex flex-jsc dimension">
                                <div v-for="(item, index) in dimensionDate" :key="index" :class="[
                                    'dimensiondate',
                                    daily_index == index ? 'dimensiondate-check' : '',
                                    ]" @click="changeDaily(index)">
                                    <span> {{ item }}</span>
                                </div>
                            </div>
                        </div>
                        <van-popup v-model="showCalendarStart" round position="bottom" class="popup-picker-custom">
                            <van-datetime-picker
                                v-model="defaultDate[0]"
                                :min-date="minDate"
                                :max-date="maxDate"
                                type="datetime"
                                @confirm="onConfirmTime($event, 1)"
                                @cancel="showCalendarStart = false"
                                item-height="1.25rem"
                                :formatter="formatter"
                            />
                        </van-popup>
                        <van-popup v-model="showCalendarEnd" round position="bottom" class="popup-picker-custom">
                            <van-datetime-picker
                                v-model="defaultDate[1]"
                                :min-date="minDate"
                                :max-date="maxDate"
                                type="datetime"
                                @confirm="onConfirmTime($event, 2)"
                                @cancel="showCalendarEnd = false"
                                item-height="1.25rem"
                                :formatter="formatter"
                            />
                        </van-popup>

                        <button class="search-btn mg-rt20" @click="handleFifler">筛 选</button>
                        <button class="search-btn" @click="resetTemp">重 置</button>
                    </div>
                    <div class="dailydata-box">
                        <div class="dailydata-item">
                            <div class="color-333 ft-32 flex flex-ac flex-jsb width-full mg-bt25">
                                <span class="ft-bold daily-item-title" style="width: 66%;">营业实收</span>
                                <span class="ft-bold text-right" style="width: 33%;">￥{{parseFloat(dailyData.day_income).toFixed($store.state.digits)}}</span>
                            </div>
                            <div class="color-333 ft-26 flex flex-ac flex-jsb width-full mg-bt20">
                                <span style="width: 66%;" class="pd-lt35">订单实收</span>
                                <span style="width: 33%;" class="text-right">￥{{parseFloat(dailyData.sale_amount).toFixed($store.state.digits) || '0.00'}}</span>
                            </div>
                            <div class="color-333 ft-26 flex flex-ac flex-jsb width-full mg-bt20">
                                <span style="width: 66%;" class="pd-lt35">储值实收</span>
                                <span style="width: 33%;" class="text-right">￥{{parseFloat(dailyData.recharge_income).toFixed($store.state.digits) || '0.00'}}</span>
                            </div>
                            <div class="color-333 ft-26 flex flex-ac flex-jsb width-full">
                                <div style="width: 66%; display: flex;" class="pd-lt35 flex-ac">
                                    <span>不计入实收</span>
                                    <van-icon name="question" color="#999" size="0.30rem" class="mg-lt10" @touchmove="showTip" @touchend="hideTip" @mouseover="showTip" @mouseout="hideTip" />
                                </div>
                                <span style="width: 33%;" class="text-right">-￥{{parseFloat(dailyData.no_count_act).toFixed($store.state.digits)}}</span>
                            </div>
                        </div>

                        <div class="dailydata-item bd-tp-eee">
                            <div class="color-333 ft-32 flex flex-ac flex-jsb width-full mg-bt25 data-cell">
                                <span class="ft-bold daily-item-title">订单实收</span>
                                <span>{{dailyData.order_count || 0}}单</span>
                                <span class="ft-bold">￥{{parseFloat(dailyData.sale_amount).toFixed($store.state.digits) || '0.00'}}</span>
                            </div>
                            <!-- <div class="color-333 ft-26 flex flex-ac flex-jsb width-full mg-bt20 data-cell">
                                <span class="pd-lt35">应收金额</span>
                                <span>{{dailyData.order_count || 0}}笔</span>
                                <span>￥{{parseFloat(dailyData.day_discount).toFixed($store.state.digits)}}</span>
                            </div> -->
                            <div class="color-333 ft-26 flex flex-ac flex-jsb width-full data-cell">
                                <span class="pd-lt35">退款金额</span>
                                <span>{{dailyData.return_num || 0}}笔</span>
                                <span>-￥{{parseFloat(dailyData.return_amount).toFixed($store.state.digits) || '0.00'}}</span>
                            </div>
                        </div>

                        <div class="dailydata-item bd-tp-eee">
                            <div class="color-333 ft-32 flex flex-ac flex-jsb width-full mg-bt25 data-cell">
                                <span class="ft-bold daily-item-title">储值实收</span>
                                <span>{{dailyData.recharge_num || 0}}单</span>
                                <span class="ft-bold">￥{{parseFloat(dailyData.recharge_income).toFixed($store.state.digits) || '0.00'}}</span>
                            </div>
                            <div class="color-333 ft-26 flex flex-ac flex-jsb width-full data-cell">
                                <span class="pd-lt35">赠送金额</span>
                                <span>{{dailyData.give_num || 0}}笔</span>
                                <span>￥{{parseFloat(dailyData.give_amount).toFixed($store.state.digits) || '0.00'}}</span>
                            </div>
                        </div>

                        <div class="dailydata-item bd-tp-eee">
                            <div class="color-333 ft-32 flex flex-ac flex-jsb width-full mg-bt25">
                                <span class="ft-bold daily-item-title">订单收退款构成</span>
                            </div>
                            <div class="color-333 ft-26 flex flex-ac flex-jsb width-full mg-bt20 data-cell" v-if="dailyData.xj_amount > 0 || dailyData.xj_return_amount > 0">
                                <span class="pd-lt35">现金</span>
                                <span>+￥{{parseFloat(dailyData.xj_amount).toFixed($store.state.digits) || '0.00'}}</span>
                                <span>-￥{{parseFloat(dailyData.xj_return_amount).toFixed($store.state.digits) || '0.00'}}</span>
                            </div>
                            <div class="color-333 ft-26 flex flex-ac flex-jsb width-full mg-bt20 data-cell" v-if="dailyData.hy_amount > 0 || dailyData.hy_return_amount > 0">
                                <span class="pd-lt35">会员余额</span>
                                <span>+￥{{parseFloat(dailyData.hy_amount).toFixed($store.state.digits) || '0.00'}}</span>
                                <span>-￥{{parseFloat(dailyData.hy_return_amount).toFixed($store.state.digits) || '0.00'}}</span>
                            </div>
                            <div class="color-333 ft-26 flex flex-ac flex-jsb width-full mg-bt20 data-cell" v-if="dailyData.wx_amount > 0 || dailyData.wx_return_amount > 0">
                                <span class="pd-lt35">微信</span>
                                <span>+￥{{parseFloat(dailyData.wx_amount).toFixed($store.state.digits) || '0.00'}}</span>
                                <span>-￥{{parseFloat(dailyData.wx_return_amount).toFixed($store.state.digits) || '0.00'}}</span>
                            </div>
                            <div class="color-333 ft-26 flex flex-ac flex-jsb width-full mg-bt20 data-cell" v-if="dailyData.zfb_amount > 0 || dailyData.zfb_return_amount > 0">
                                <span class="pd-lt35">支付宝</span>
                                <span>+￥{{parseFloat(dailyData.zfb_amount).toFixed($store.state.digits) || '0.00'}}</span>
                                <span>-￥{{parseFloat(dailyData.zfb_return_amount).toFixed($store.state.digits) || '0.00'}}</span>
                            </div>
                            <div class="color-333 ft-26 flex flex-ac flex-jsb width-full data-cell" v-if="dailyData.ysf_amount > 0 || dailyData.ysf_return_amount > 0">
                                <span class="pd-lt35">云闪付</span>
                                <span>+￥{{parseFloat(dailyData.ysf_amount).toFixed($store.state.digits) || '0.00'}}</span>
                                <span>-￥{{parseFloat(dailyData.ysf_return_amount).toFixed($store.state.digits) || '0.00'}}</span>
                            </div>
                        </div>
                        <div v-show="isShowTip" class="sg-tip" ref="sgTip">{{tipContent}}</div>
                    </div>
                </div>
                <div style="width: 100%; height: 1.5rem;"></div>
                <div class="btns flex flex-ac flex-jc">
                    <button class="cancel" @click="closeDailyModal">取消</button>
                    <button class="confirm " @click="confirmPrintDaily">打印</button>
                </div>
            </div>
        </div>

        <popup-of-dialog 
            v-if="showDialog"
            :type="dialogType"
            :title="dialogTitle"
            :message="dialogMsg"
            :data="dialogData"
            :showCancelBtn="false"
            :showConfirmBtn="false"
            @closePopDialog="closePopDialog"
        ></popup-of-dialog>

        <div class="choose-scale-modal" v-if="show_choose_box">
            <div class="modal-content-box relative">
                <img src="../assets/images/close.png" class="close" alt srcset @click="closeBoxModal" />
                <div class="wrapper">
                    <div :class="['title', 'color-333', 'ft-38', 'flex', 'flex-ac', 'flex-jc', 'ft-bold','pd-bt50']">钱箱连接方式</div>
                    <div class="choose-scle-box">
                        <van-radio-group v-model="choose_box">
                            <van-radio name="1" icon-size="0.4rem" class="scale-radio">和成东内置</van-radio>
                            <van-radio name="2" icon-size="0.4rem" class="scale-radio">小票机</van-radio>
                            <van-radio name="3" icon-size="0.4rem" class="scale-radio">美团内置</van-radio>
                            <!-- <van-radio name="4" icon-size="3rem" class="scale-radio">蓝牙打印机</van-radio> -->
                        </van-radio-group>
                        <button class="clear-scale" @click="choose_box = '';">清空选择</button>
                    </div>
                </div>
                <div style="height: 1.5rem;"></div>
                <!-- 确认/取消 -->
                <div class="btns flex flex-jc">
                    <button class="cancel" @click="closeBoxModal">取消</button>
                    <button class="confirm " @click="confirmBoxModal">保存</button>
                </div>
            </div>
        </div>

        <van-notice-bar
            class="global-notify-box"
            v-show="isShowNotify"
            mode="closeable"
            left-icon="volume-o"
            color="#000"
            background="#ffede9"
            @close="closeNotify"
        >
            {{notifyContent}}
        </van-notice-bar>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { openBox } from '../utils/outPrint';
import { _typeofEnv, getLocalIp, printTestDaily, formatTimeWitchLine, getBeforeDate, datetimePickerFormatter, formatTime } from '../utils/util'
import popupOfDialog from '@/components/popupOfDialog.vue';
export default {
    name: "dcheader",
    data() {
        return {
            isShowModal: false,
            originPaw: '',
            managerMode: 0, // // 1,改为管理模式  0，改为普通模式
            errorMsg: '',
            isShowDaily: false, // 日报弹窗
            dailyData: {}, // 日报数据
            isShowTip: false,
            tipContent: '',
            showDialog: false,
            dialogType: '',
            dialogTitle: '',
            dialogMsg: '',
            dialogData: {},
            isApp: '',
            dimensionDate: ["今天", "昨天", "7天", "30天"],
            daily_index: 0,
            start_time: '',
            end_time: '',
            isShowOpenLoading: false,
            defaultDate: [],
            startDateTime: 0,
            endDateTime: 0,
            showCalendarStart: false,
            showCalendarEnd: false,
            minDate: new Date(),
            maxDate: new Date(),
            formatter: datetimePickerFormatter,
            show_choose_box: false,
            choose_box: '',
        };
    },
    components: {
        'popup-of-dialog': popupOfDialog,
    },
    computed: {
        ...mapGetters({ log: "log", shop: 'shop', noticeList: 'noticeList' }),
        connected() {
            return this.$store.state.connected;
        },
        showOrderLoading() {
            return this.$store.state.showOrderLoading || false;
        },
        changeModelText() {
            if (this.shop.user_model == 1) {
                return '切换至经营模式'
            } else {
                return '切换至管理模式'
            }
        },
        changeModelTextH() {
            if (this.shop.user_model == 1) {
                return '管理模式'
            } else {
                return '经营模式'
            }
        },
        localIp() {
            let ip = '';
            if (this.nowDevice == 'android' || this.nowDevice == 'mt_android') {
                ip = this.$store.state.deviceInfo.ip || '';
            } else if (this.nowDevice == 'windows') {
                ip = this.$store.state.deviceIp || '';
            }
            return ip;
        },
        account() {
            return localStorage.account || '';
        },
        nowTime() {
            return this.$store.state.nowTimeStr || '';
        },
        nowDevice() {
            return localStorage.nowDevice || '';
        },
        isShowNotify() {
            return this.$store.state.isShowNotify;
        },
        notifyContent() {
            return this.$store.state.notifyContent;
        },
    },
    methods: {
        closeNotify() {
            this.$store.commit('updateIsShowNotify', false);
        },
        confirmBoxModal() {
            let query = new FormData();
            query.append("name", this.shop.name);
            query.append("phone", this.shop.phone);
            query.append("address", this.shop.address);
            query.append("workTimeS", this.shop.workTimeS);
            query.append("workTimeE", this.shop.workTimeE);
            query.append('scale_type', this.shop.scale_type || '');
            query.append('box_type', this.choose_box);
            this.$api.updateShopInfo(query).then(async (res) => {
                if (res.code == 1) {
                    this.$toast("保存成功，门店设置已更新");
                    localStorage.setItem('box_type', this.choose_box);
                    this.closeBoxModal();
                } else {
                    this.$toast(res.msg || "修改门店信息失败");
                }
            });
        },
        closeBoxModal() {
            this.show_choose_box = false;
        },
        openChooseBox() {
            this.choose_box = localStorage.box_type;
            this.show_choose_box = true;
        },
        resetTemp() {
            this.start_time = '';
            this.end_time = '';
            this.daily_index = 0;
            this.getselectTime();
            this.getShopDaily();
        },
        onConfirmTime(event, type) {
            // console.log(event, type);
            const selectedDate = new Date(event);
            
            // 经营模式限制
            if (this.shop.user_model == 0) {
                const today = new Date();
                if (selectedDate.getDate() !== today.getDate() || 
                    selectedDate.getMonth() !== today.getMonth() || 
                    selectedDate.getFullYear() !== today.getFullYear()) {
                    this.$toast("经营模式只能查询今天的日报");
                    return;
                }
            }
            
            if (type == 1) {
                // 检查跨年查询
                if (this.endDateTime > 0) {
                    const endDate = new Date(this.endDateTime);
                    if (selectedDate.getFullYear() !== endDate.getFullYear()) {
                        this.$toast("不支持跨年查询");
                        return;
                    }
                }
                
                if (
                    this.endDateTime > 0 &&
                    selectedDate.getTime() > this.endDateTime
                ) {
                    this.$toast("开始日期不能大于结束日期");
                    return;
                }
                this.startDateTime = selectedDate.getTime();
                this.start_time = formatTime(event, 'yyyy-MM-dd hh:mm');
                this.showCalendarStart = false;
            } else {
                // 检查跨年查询
                if (this.startDateTime > 0) {
                    const startDate = new Date(this.startDateTime);
                    if (selectedDate.getFullYear() !== startDate.getFullYear()) {
                        this.$toast("不支持跨年查询");
                        return;
                    }
                }
                
                if (
                    this.startDateTime > 0 &&
                    selectedDate.getTime() < this.startDateTime
                ) {
                    this.$toast("结束日期不能小于开始日期");
                    return;
                }
                this.endDateTime = selectedDate.getTime();
                this.end_time = formatTime(event, 'yyyy-MM-dd hh:mm');
                this.showCalendarEnd = false;
            }
        },
        handleFifler() {
            if (this.shop.user_model == 0) {
                const today = new Date();
                const startDate = new Date(this.start_time);
                const endDate = new Date(this.end_time);
                
                if (startDate.getDate() !== today.getDate() || 
                    startDate.getMonth() !== today.getMonth() || 
                    startDate.getFullYear() !== today.getFullYear() ||
                    endDate.getDate() !== today.getDate() || 
                    endDate.getMonth() !== today.getMonth() || 
                    endDate.getFullYear() !== today.getFullYear()) {
                    this.$toast("经营模式只能查询今天的日报");
                    return;
                }
            }
            
            if (this.start_time == "" && this.end_time != "") {
                this.$toast("请选择开始日期");
                return;
            }
            if (this.start_time != "" && this.end_time == "") {
                this.$toast("请选择结束日期");
                return;
            }
            
            // 检查跨年查询
            if (this.start_time && this.end_time) {
                const startDate = new Date(this.start_time);
                const endDate = new Date(this.end_time);
                if (startDate.getFullYear() !== endDate.getFullYear()) {
                    this.$toast("不支持跨年查询");
                    return;
                }
            }
            
            this.getShopDaily();
        },
        getselectTime() {
            switch (this.daily_index) {
                case 0:
                    this.start_time = formatTimeWitchLine(new Date()) + ' 00:00';
                    this.end_time = formatTimeWitchLine(new Date()) + ' 23:59';
                    this.defaultDate = [new Date(), new Date()];
                    break;
                case 1:
                    let beforeDate = getBeforeDate(1);
                    this.start_time = formatTimeWitchLine(beforeDate) + ' 00:00';
                    this.end_time = formatTimeWitchLine(beforeDate) + ' 23:59';
                    this.defaultDate = [beforeDate, new Date()];
                    break;
                case 2:
                    let beforeDate_1 = getBeforeDate(6);
                    this.start_time = formatTimeWitchLine(beforeDate_1) + ' 00:00';
                    this.end_time = formatTimeWitchLine(new Date()) + ' 23:59';
                    this.defaultDate = [beforeDate_1, new Date()];
                    break;
                case 3:
                    let beforeDate_2 = getBeforeDate(29);
                    this.start_time = formatTimeWitchLine(beforeDate_2) + ' 00:00';
                    this.end_time = formatTimeWitchLine(new Date()) + ' 23:59';
                    this.defaultDate = [beforeDate_2, new Date()];
                    break;
                default:
                    break;
            }
        },
        changeDaily(i) {
            // 经营模式只能查询今天
            if (this.shop.user_model == 0 && i !== 0) {
                this.$toast("经营模式只能查询今天的日报");
                return;
            }
            
            if (this.daily_index != i) {
                this.daily_index = i;
                this.getselectTime();
                this.getShopDaily();
            }
        },
        showIpContModal() {
            this.dialogType = 'showIp';
            this.dialogTitle = 'IP';
            this.dialogMsg = `本机IP地址：【${this.localIp}】`;
            this.showDialog = true;
        },
        closePopDialog() {
            this.showDialog = false;
        },
        // clickHeadNotice(item) {
        //     let query = new FormData();
        //     query.append('type', 1); // type 1，修改轮播消息状态   2，修改打印状态
        //     query.append('order_id', item.id);
        //     this.$api.editTipStatus(query);
        //     if (this.$route.name != 'orderList') {
        //         this.$router.replace({
        //             name: 'orderList',
        //             params: {
        //                 order_id: item.id,
        //             }
        //         })
        //     } else {
        //         this.$emit('clickHeadNotice',  { order_id: item.id });
        //     }
        // },
        showTip(e) {
            this.tipContent = '会员余额支付不计入实收。因为会员余额在充值时属于储值收入，在消费时属于订单收入，所以需要扣减此部分';
            this.isShowTip = true;
            this.mouseFllow(e);
        },
        hideTip() {
            this.isShowTip = false;
        },
        mouseFllow(e) {
            // 鼠标跟随tip
            let sgTip = this.$refs.sgTip;
            var x = e.pageX,
                y = e.pageY,
                offsetX = -20,
                offsetY = 15;
            sgTip.style.left = x + offsetX + "px";
            sgTip.style.top = y + offsetY + "px";
        },
        openQianxiang() {
            this.isShowOpenLoading = true;
            setTimeout(() => {
                this.isShowOpenLoading = false;
            }, 500);
            //  打开钱箱
            if (this.nowDevice == 'android' || this.nowDevice == 'mt_android') {
                openBox();
            } else if (this.nowDevice == 'windows') {
                this.$device.openCasher();
            }
        },
        // 切换模式
        changeModel() {
            this.errorMsg = '';
            if (this.shop.user_model == 1) { // 需要切换至经营模式
                this.managerMode = 0;
                this.isShowModal = true;
            } else { // 需要切换至管理模式
                this.managerMode = 1;
                this.isShowModal = true;
            }
        },
        closeModal() {
            this.isShowModal = false;
            this.managerMode = 0;
            this.originPaw = '';
        },
        confirmChange() {
            if (this.managerMode == 1 && this.originPaw == "") {
                this.errorMsg = '管理密码不能为空'
                return;
            }
            let data = new FormData();
            data.append("type", this.managerMode); // 1,改为管理模式  0，改为普通模式
            if (this.managerMode) {
                data.append("paw", this.originPaw); // 管理密码 type=1时必填
            }
            this.$api.changeModel(data).then((res) => {
                if (res.code == 1) {
                    this.$toast(res.msg || "操作成功");
                    this.closeModal();
                    this.getShop();
                } else {
                    this.errorMsg = res.msg || "操作失败";
                }
            });
        },
        getShop() {
            this.$api.getShopInfo().then((res) => {
                if (res.code == 1) {
                // user_model:1，表示是店长模式 0，表示为普通模式
                // vip_level:0，表示只有大厅（退菜不用发送不提示） 1，有大厅和服务员（退菜不提示） 2，大厅服务员后厨都有（发送提示就按现在的逻辑判断）
                this.$store.dispatch("setShopInfo", res.data);
                }
            });
        },
        openDaily() {
            this.daily_index = 0;
            this.getselectTime();
            if (this.shop.user_model == 0) { // 经营模式
                // 经营模式只能查询今天
                this.daily_index = 0; // 强制设置为"今天"
                this.start_time = formatTimeWitchLine(new Date()) + ' 00:00';
                this.end_time = formatTimeWitchLine(new Date()) + ' 23:59';
                this.defaultDate = [new Date(), new Date()];
            }
            this.getShopDaily();
        },
        getShopDaily() {
            let params = {
                start_time: this.start_time,
                end_time: this.end_time,
                is_opening_hours: 0, // 是否为营业时间进行统计，1：按照营业时间统计，0：按照自然日统计
            }
            this.$api.shopDaily(params).then(res => {
                if (res.code == 1) {
                    this.dailyData = res.data;
                    this.isShowDaily = true;
                } else {
                    this.$toast(res.msg);
                }
            })
        },
        closeDailyModal() {
            this.isShowDaily = false;
        },
        confirmPrintDaily() {
            const printData = {
                type: 21,
                data: this.dailyData
            }
            let result1 = printTestDaily(printData, 21);
            this.$bus.$emit('dailyPrint', result1);
        }
    },
    mounted() {

    },
    created() {
        //let newD = new Date().setMonth(new Date().getMonth() - 2)
        //this.minDate = new Date(newD);
        let newD = new Date().setFullYear(new Date().getFullYear() - 1); // 允许查询近10年的数据
        newD = new Date(newD).setHours(0);
        newD = new Date(newD).setMinutes(0);
        const currentYear = new Date().getFullYear();
        this.minDate = new Date(currentYear - 0, 0, 1); // 设置为1年前的1月1日
        this.maxDate = new Date();
    }
};
</script>

<style lang="less" scoped>
.global-notify-box {
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  right: 0;
  z-index: 300;
  font-size: 0.4rem;
  height: 0.85rem;
  /deep/.van-icon {
    font-size: 0.4rem;
  }
  /deep/.van-notice-bar__left-icon {
    margin-right: 0.2rem;
  }
  /deep/.van-notice-bar__right-icon {
    margin-left: 0.2rem;
  }
}
.choose-scale-modal {
    text-align: left;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 3000;
    display: flex;
    align-items: center;
    justify-content: center;
        
    .modal-content-box {
        width: 12rem;
        max-height: 12rem;
        height: fit-content;
        border-radius: 0.13rem;
        background-color: #fff;
    }
    .close {
        width: 0.38rem;
        height: 0.38rem;
        position: absolute;
        right: 0.3rem;
        top: 0.3rem;
        z-index: 10;
    }
    .wrapper {
        padding: 0rem 0.7rem;
        position: relative;
    
        .title {
            padding-top: 0.5rem;
            border-bottom: 0.02rem solid rgba(204, 204, 204, 1);
        }
    }
    .btns {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1.25rem;
        .confirm,
        .cancel {
            color: #fff;
            min-width: 2.87rem;
            height: 0.9rem;
            border-radius: 0.13rem;
            font-size: 0.36rem;
            padding: 0 0.3rem;
        }
        .cancel {
            background: #EAEAEA;
            color: #666666;
            margin-right: 1rem;
        }
        .confirm {
            background: #FE724F;
        }
    }

    .choose-scle-box {
        margin: 0.4rem 1.3rem;
        .scale-radio {
            margin-bottom: 0.33rem;
            font-size: 0.36rem;
        }
        .scale-radio:last-child {
            margin-bottom: 0;
        }
        .clear-scale {
            width: 1.6rem;
            height: 0.7rem;
            border-radius: 0.13rem;
            font-size: 0.3rem;
            background: #FE724F;
            color: #fff;
        }
    }
}
.search-value {
    display: flex;
    flex-wrap: wrap;
    // background: #fff;
    padding: 0 0.3rem 0 0;
    margin: 0.2rem 0 0 0;
    align-items: center;
    justify-content: center;

    .search-item {
        margin: 0 0.5rem 0 0.4rem;

        .dimension {
            border-radius: 0.13rem;
            font-weight: 400;
            font-size: 0.36rem;
            color: #666666;
            flex-wrap: nowrap;

            .dimensiondate {
                width: 1.25rem;
                height: 0.75rem;
                background: #ffffff;
                border: 0.02rem solid #dedede;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: -0.02rem;
            }

            .dimensiondate:first-child {
                border-radius: 0.13rem 0 0 0.13rem;
            }
            .dimensiondate:last-child {
                border-radius: 0 0.13rem 0.13rem 0;
            }

            .dimensiondate-check {
                background: #fe724f;
                border-color: #fe724f;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-left: -0.02rem;
                color: #fff;
            }
        }
    }

    .ordernum-input {
        border: 0.02rem #DEDEDE solid;
        width: 4.5rem;
        height: 0.75rem;
        border-radius: 0.13rem;
        font-size: 0.3rem;
        padding-left: 0.2rem;
    }

    .search-btn {
        background: #fe724f;
        font-size: 0.36rem;
        color: #fff;
        height: 0.75rem;
        padding: 0 0.35rem;
        border-radius: 0.13rem;
    }

    .search-date-input {
        width: 3.95rem;
        font-size: 0.36rem;
    }
}
.mg-rt5 {
    margin-right: 0.05rem;
}
.notice-box {
    width: 30%;
    margin-right: 0.3rem;
    height: 100%;
    .notice-cont {
        width: 100%;
        background: transparent;
        height: 100%;
        /deep/.van-notice-bar__wrap {
            height: 100% !important;
        }
        /deep/.van-notice-bar__content {
            width: 100%;
        }
        /deep/.van-swipe-item {
            color: #FE724F;
            display: flex;
            align-items: center;
            white-space: pre-wrap;
            line-height: 1;
            height: 100% !important;
            font-size: 0.36rem;
        }
    }
    .notice-swipe {
        height: 1rem;
        /deep/.van-swipe__track {
            height: 100% !important;
        }
    }
}
.sg-tip {
    position: fixed;
    width: 5rem;
    height: auto;
    background: #fff;
    border: 0.02rem #666 solid;
    border-radius: 0.13rem;
    padding: 0.2rem;
    box-shadow: 0 0 0.07rem 0.07rem rgba(229, 229, 229, 0.26);
    line-height: 1.5;
    font-size: 0.24rem;
}
.daily-modal {
    .changemodel-box {
        width: 38vw !important;
        max-height: 90vh !important;
        height: fit-content !important;
    }

    .modalcont {
        max-height: calc(90vh - 4rem);
        height: fit-content;
        overflow-y: scroll;
        .dailydata-box {
            padding: 0.1rem 0.8rem;
            width: 100%;

            .dailydata-item {
                width: 100%;
                padding-bottom: 0.2rem;
                padding-top: 0.2rem;

                .daily-item-title {
                    position: relative;
                }
                .daily-item-title::before {
                    position: absolute;
                    content: '*';
                    top: 0.05rem;
                    left: -0.25rem;
                    color: #333;
                }
            }

            .data-cell span {
                width: 33%;
            }
            .data-cell span:nth-child(1) {
                text-align: left;
            }
            .data-cell span:nth-child(2) {
                text-align: center;
            }
            .data-cell span:nth-child(3) {
                text-align: right;
            }
        }
    }
    .btns {
        position: absolute;
        bottom: 0;
    }
}
.changemodel-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 20;
    display: flex;
    align-items: center;
    justify-content: center;

    .changemodel-box {
        background: #fff;
        width: 13rem;
        max-height: 12rem;
        border-radius: 0.13rem;
        position: relative;

        .modaltitle {
            color: #333;
            font-size: 0.4rem;
            font-weight: bold;
            padding-top: 0.51rem;
			border-bottom: 0.02rem solid rgba(204, 204, 204, 1);
            padding-bottom: 0.51rem;
            text-align: center;
        }

        .close {
            width: 0.38rem;
            height: 0.38rem;
            right: 0.3rem;
            top: 0.3rem;
            z-index: 10;
        }

        .modalcont-item {
            width: 84%;
            padding: 0.85rem 0.5rem 0;
            margin: auto;
            min-height: 23vh;

            .modalcont-label {
                font-size: 0.4rem;
                margin-right: 0.2rem;
            }

            .modalcont-input {
                height: 1rem;
                flex: 1;
                border-radius: 0.13rem;
                border: 0.01rem rgba(204, 204, 204, 1) solid;
                font-size: 0.36rem;
                padding: 0 0.2rem;
            }
        }

        .modalcont-text {
            font-size: 0.4rem;
            margin: 1rem 0.5rem 2rem;
            text-align: center;
        }
    }

    .btns {
		width: 100%;
		height: 1.5rem;
		.confirm,
		.cancel {
			color: #fff;
			width: 2.87rem;
			height: 0.9rem;
			border-radius: 0.13rem;
			font-size: 0.36rem;
		}
		.cancel {
			background: #EAEAEA;
			color: #666666;
			margin-right: 1rem;
		}
		.confirm {
			background: #FE724F;
		}
	}
}
.dcheader {
    position: fixed;
    top: 0;
    right: 0;
    left: 2rem;
    width: calc(100vw - 2rem);
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 1.2rem;
    z-index: 200;
    padding: 0 0.2rem;

    .logoimg {
        width: 0.8rem;
        height: 0.8rem;
        border-radius: 50%;
        margin-right: 0.2rem;
    }

    .connectedstatus {
        width: 0.55rem;
        height: 0.55rem;
    }

    .ipimg {
        width: 0.52rem;
        height: 0.52rem;
    }

    .timeimg {
        width: 0.55rem;
        height: 0.55rem;
    }

    .openqianxiang-btn {
        // background: #FE724F;
        color: #fff;
        border-radius: 0.13rem;
        padding: 0 0.2rem;
        height: 0.8rem;
        font-size: 0.34rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/dcheader.vue